import React, { ReactNode, useRef } from 'react'

interface TooltipProps{
  children: ReactNode;
  tooltip?: string;
  list?: string[];
}

const Tooltip: React.FC<TooltipProps> = ({children, tooltip, list}) => {
  const tooltipRef = useRef<HTMLSpanElement>(null);
  const container = useRef<HTMLDivElement>(null);
  
  return (
    <div
      ref={container}
      onMouseEnter={({ clientX }) => {
        if (!tooltipRef.current || !container.current) return;
        const { left } = container.current.getBoundingClientRect();

        tooltipRef.current.style.left = clientX - left - 100 + "px";
      }}
      className='group relative inline-block'
    >
      {children}
      {tooltip ? (
        <div className="flex flex-col opacity-0 items-center transition invisible group-hover:opacity-100 group-hover:visible absolute mt-2 top-5 -ml-[10.5px]">
          <div className="border-l-[8px] border-r-[8px] border-l-transparent border-r-transparent border-b-[#000] border-b-[10px] border-solid"></div>
          <div
            className='shadow z-50 bg-[#000] text-white p-[6px] rounded whitespace-nowrap font-Inter text-[10.5px]'
          >
          {tooltip}
          </div>
        </div>
        
        )
        : 
        <div className="flex flex-col opacity-0 items-center transition invisible group-hover:opacity-100 group-hover:visible absolute mt-2 top-full -ml-5 lg:-ml-9">
          <div className="border-l-[8px] border-r-[8px] border-l-transparent border-r-transparent border-b-[#000] border-b-[10px] border-solid"></div>
          <div
            className='shadow bg-[#000] text-white p-[6px] rounded whitespace-nowrap font-Inter lg:text-xs text-[7px]'
          >
          {list?.map((a, index) =>(
            <div className="flex flex-col gap-1" key={index*2}>
              {a}
            </div>
          ))}
          </div>
        </div>
      } 
    </div>
  )
}

export default Tooltip